module.exports = __webpack_public_path__ + "img/icon-help.d870959d.svg";